import { render, staticRenderFns } from "./FCOStatusLabel.vue?vue&type=template&id=4ce02a1c"
import script from "./FCOStatusLabel.vue?vue&type=script&lang=js"
export * from "./FCOStatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports